module.exports = __webpack_public_path__ + "static/img/education1.768aeb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/education1.jpg
// module id = K5M1
// module chunks = 18